"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUOTE_STREAM_CHANNEL = (hash) => (`liquid:qex:stream-${hash}`);
exports.QUOTE_STREAM_B2B_CHANNEL = (hash) => (`liquid:qex-b2b:stream-${hash}`);
